import CustomMargin from "../../../components/custom-margin";
import EyeIcon from '../../../assets/eye-vision.svg';
import TargetIcon from '../../../assets/target-mission.svg';
import HandIcon from '../../../assets/hand-values.svg';

export default function MissionSection(){
    return (
        <CustomMargin>
            {/* <div className="flex text-base lg:flex-col xxl:flex-row xxl:items-center">
                <div className="p-5 xxl:pt-0 lg:w-full sm:text-center lg:text-center xxl:text-left">
                    <div className="mt-5 xxl:mt-0">
                        <h1 className="font-fontMontserrat text-4xl lg:text-6xl xxl:text-5xl">MISSION</h1>
                        <p className="text-xl">Quilaton Law Office aims to provide affordable and seamless legal services to our clients by effectively combining our highly diverse and specialized legal skills and passion to serve the people — locally and globally.</p>
                    </div>
                    <div className="mt-10">
                        <h1 className="font-fontMontserrat text-4xl lg:text-6xl xxl:text-5xl">VISION</h1>
                        <p className="text-xl">The Quilaton Law Office envisions a future where our law firm is among the superior law firms in the country capable of providing timely but top-notch services to our growing clients.</p>
                        <p className="text-xl">Our law firm will continuously be the avenue for clients seeking peace of mind in their legal concerns at an affordable rate.</p>
                    </div>
                    <div className="mt-10">
                        <h1 className="font-fontMontserrat text-4xl lg:text-6xl xxl:text-5xl">CORE VALUES</h1>
                        <p className="text-xl">Our core values include collaboration, compassion and empathy, efficiency, integrity, innovation and sustainability, and justice.</p>
                    </div>
                </div>
            </div> */}
            <div class="grid gap-10 md:grid-cols-2 lg:grid-cols-3 p-8 text-center">
                <div class="bg-white shadow-xl rounded-2xl p-10 border-t-8 border-yellow-500 hover:shadow-2xl transition flex flex-col items-center">
                    {/* <img 
                    alt="Target Icon"
                    src={TargetIcon}
                    class="h-24 w-24 mb-6 filter"
                    /> */}
                    <h1 class="font-fontMontserrat text-4xl lg:text-5xl font-extrabold mb-6">MISSION</h1>
                    <p class="text-l lg:text-xl font-medium leading-relaxed text-black">
                    Quilaton Law Office aims to provide affordable and seamless legal services to our clients by effectively combining our highly diverse and specialized legal skills and passion to serve the people — locally and globally.
                    </p>
                </div>

                <div class="bg-white shadow-xl rounded-2xl p-10 border-t-8 border-yellow-500 hover:shadow-2xl transition flex flex-col items-center">
                    {/* <img 
                    alt="Eye Icon"
                    src={EyeIcon}
                    class="h-24 w-24 mb-6 filter"
                    /> */}
                    <h1 class="font-fontMontserrat text-4xl lg:text-5xl font-extrabold mb-6">VISION</h1>
                    <p class="text-l lg:text-xl font-medium leading-relaxed text-black mb-4">
                    The Quilaton Law Office envisions a future where our law firm is among the superior law firms in the country capable of providing timely but top-notch services to our growing clients.
                    </p>
                    <p class="text-l lg:text-xl font-medium leading-relaxed text-black">
                    Our law firm will continuously be the avenue for clients seeking peace of mind in their legal concerns at an affordable rate.
                    </p>
                </div>

                <div class="bg-white shadow-xl rounded-2xl p-10 border-t-8 border-yellow-500 hover:shadow-2xl transition flex flex-col items-center">
                    {/* <img 
                    alt="Handshake Icon"
                    src={HandIcon}
                    class="h-24 w-24 mb-6 filter"
                    /> */}
                    <h1 class="font-fontMontserrat text-4xl lg:text-5xl font-extrabold mb-6">CORE VALUES</h1>
                    <p class="text-l lg:text-xl font-medium leading-relaxed text-black">
                    Our core values include collaboration, compassion and empathy, efficiency, integrity, innovation and sustainability, and justice.
                    </p>
                </div>
            </div>
        </CustomMargin>
    )
}